var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hy-datePicker',{model:{value:(_vm.newDate),callback:function ($$v) {_vm.newDate=$$v},expression:"newDate"}}),_c('h1',[_vm._v(_vm._s(_vm.newDate))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }